<template>
  <section>
    <google-pixel :enabled="true"></google-pixel>
    <r-title>{{ $t('registration.thanks') }}</r-title>

    <div v-if="goHomeMessage">
      <div class="text">
        <div v-html="goHomeMessage" />
      </div>
      <div class="buttons">
        <a-button @click="goNext">{{ $t('go.home') }}</a-button>
      </div>
    </div>

    <div v-else>
      <div class="text">
        <div>{{ $t('registration.you.registered') }}</div>
        <div>
          {{ $t('registration.next.step') }}
        </div>
        <div class="step">
          <div>{{ $t('registration.next.step.description.p1') }}</div>
          <div>{{ $t('registration.next.step.description.p2', { browser: browserName }) }}</div>
        </div>
      </div>
      <div class="buttons">
        <install-extension />
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import RTitle from '@/components/common/Title.vue';
import GooglePixel from '@/components/common/GooglePixel.vue';
import InstallExtension from '@/components/login/InstallExtension.vue';

import { isSupportedBrowser, getBrowserName, getBrowserData } from '@/services/browser';

import { ROUTER_PATHS } from '@/router/constants';

export default {
  components: {
    RTitle,
    InstallExtension,
    GooglePixel,
  },
  computed: {
    ...mapGetters(['extensionInstalled']),
    goHomeMessage() {
      if (this.extensionInstalled) {
        return this.$t('extension.installed');
      }

      if (!isSupportedBrowser()) {
        return this.$t('browser.not.supported', getBrowserData());
      }

      return '';
    },
    browserName() {
      return getBrowserName();
    },
  },
  methods: {
    goNext() {
      this.$router.push(ROUTER_PATHS.ACCOUNT);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/metrics.scss';

section {
  text-align: center;
}

.text div {
  margin: $base 0;
  line-height: 20px;
}

div.step {
  margin-top: $double;
}

.buttons {
  display: flex;
  justify-content: space-around;
}
</style>
